module.exports = "/img/8.6165a7.webp";